import _toConsumableArray from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _get from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { MediaChromeButton } from "./media-chrome-button.js";
import { globalThis, document } from "./utils/server-safe-globals.js";
import { MediaUIEvents, MediaUIAttributes } from "./constants.js";
import { verbs } from "./labels/labels.js";
import { getBooleanAttr, getStringAttr, setBooleanAttr, setStringAttr } from "./utils/element-utils.js";
var enterFullscreenIcon = "<svg aria-hidden=\"true\" viewBox=\"0 0 26 24\">\n  <path d=\"M16 3v2.5h3.5V9H22V3h-6ZM4 9h2.5V5.5H10V3H4v6Zm15.5 9.5H16V21h6v-6h-2.5v3.5ZM6.5 15H4v6h6v-2.5H6.5V15Z\"/>\n</svg>";
var exitFullscreenIcon = "<svg aria-hidden=\"true\" viewBox=\"0 0 26 24\">\n  <path d=\"M18.5 6.5V3H16v6h6V6.5h-3.5ZM16 21h2.5v-3.5H22V15h-6v6ZM4 17.5h3.5V21H10v-6H4v2.5Zm3.5-11H4V9h6V3H7.5v3.5Z\"/>\n</svg>";
var slotTemplate = document.createElement("template");
slotTemplate.innerHTML = "\n  <style>\n  :host([".concat(MediaUIAttributes.MEDIA_IS_FULLSCREEN, "]) slot:not([name=exit]):not([name=icon]) {\n    display: none !important;\n  }\n\n  ", "\n  :host(:not([").concat(MediaUIAttributes.MEDIA_IS_FULLSCREEN, "])) slot:not([name=enter]):not([name=icon]) {\n    display: none !important;\n  }\n  </style>\n\n  <slot name=\"icon\">\n    <slot name=\"enter\">").concat(enterFullscreenIcon, "</slot>\n    <slot name=\"exit\">").concat(exitFullscreenIcon, "</slot>\n  </slot>\n");

var updateAriaLabel = function updateAriaLabel(el) {
  var label = el.mediaIsFullscreen ? verbs.EXIT_FULLSCREEN() : verbs.ENTER_FULLSCREEN();
  el.setAttribute("aria-label", label);
};

var MediaFullscreenButton = /*#__PURE__*/function (_MediaChromeButton) {
  _inherits(MediaFullscreenButton, _MediaChromeButton);

  var _super = _createSuper(MediaFullscreenButton);

  function MediaFullscreenButton() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MediaFullscreenButton);

    return _super.call(this, _objectSpread({
      slotTemplate: slotTemplate
    }, options));
  }

  _createClass(MediaFullscreenButton, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      updateAriaLabel(this);

      _get(_getPrototypeOf(MediaFullscreenButton.prototype), "connectedCallback", this).call(this);
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      if (attrName === MediaUIAttributes.MEDIA_IS_FULLSCREEN) {
        updateAriaLabel(this);
      }

      _get(_getPrototypeOf(MediaFullscreenButton.prototype), "attributeChangedCallback", this).call(this, attrName, oldValue, newValue);
    }
  }, {
    key: "mediaFullscreenUnavailable",
    get: function get() {
      return getStringAttr(this, MediaUIAttributes.MEDIA_FULLSCREEN_UNAVAILABLE);
    },
    set: function set(value) {
      setStringAttr(this, MediaUIAttributes.MEDIA_FULLSCREEN_UNAVAILABLE, value);
    }
  }, {
    key: "mediaIsFullscreen",
    get: function get() {
      return getBooleanAttr(this, MediaUIAttributes.MEDIA_IS_FULLSCREEN);
    },
    set: function set(value) {
      setBooleanAttr(this, MediaUIAttributes.MEDIA_IS_FULLSCREEN, value);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var eventName = this.mediaIsFullscreen ? MediaUIEvents.MEDIA_EXIT_FULLSCREEN_REQUEST : MediaUIEvents.MEDIA_ENTER_FULLSCREEN_REQUEST;
      this.dispatchEvent(new globalThis.CustomEvent(eventName, {
        composed: true,
        bubbles: true
      }));
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return [].concat(_toConsumableArray(_get(_getPrototypeOf(MediaFullscreenButton), "observedAttributes", this)), [MediaUIAttributes.MEDIA_IS_FULLSCREEN, MediaUIAttributes.MEDIA_FULLSCREEN_UNAVAILABLE]);
    }
  }]);

  return MediaFullscreenButton;
}(MediaChromeButton);

if (!globalThis.customElements.get("media-fullscreen-button")) {
  globalThis.customElements.define("media-fullscreen-button", MediaFullscreenButton);
}

var media_fullscreen_button_default = MediaFullscreenButton;
export { media_fullscreen_button_default as default };